import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
let OrganizationMixin = class OrganizationMixin extends Vue {
    account;
    get isOrganizationWithBranches() {
        return Boolean(this.account.organization_type === 'with_branches');
    }
    get isOrganizationWithHubs() {
        return Boolean(this.account.organization_type === 'with_hubs');
    }
    get isOrganizationWithAll() {
        return Boolean(this.account.organization_type === 'with_all');
    }
    get currentType() {
        return this.account.organization_type || this.user().account_kind;
    }
};
__decorate([
    State(state => state.GlobalStore.account)
], OrganizationMixin.prototype, "account", void 0);
OrganizationMixin = __decorate([
    Component
], OrganizationMixin);
export default OrganizationMixin;
;
